export const brandColors: Record<
	string,
	{
		name: string
		backgroundColor: string
		lightBackgroundColor: string
		defaultStyle?: string
		collapsed?: string
		selected?: string
	}
> = {
	acata: {
		name: 'Acata',
		backgroundColor: '#509e2f',
		lightBackgroundColor: 'default',
	},
	adtab_black: {
		name: 'Adtab Black',
		backgroundColor: '#1d1d1b',
		lightBackgroundColor: 'default',
	},
	adtab_white: {
		name: 'Adtab White',
		backgroundColor: '#ffffff',
		lightBackgroundColor: 'default',
	},
	adtab_yellow: {
		name: 'Adtab Yellow',
		backgroundColor: '#ffd400',
		lightBackgroundColor: 'default',
	},
	advantage: {
		name: 'Advantage',
		backgroundColor: '#007040',
		lightBackgroundColor: '#e5f0eb',
	},
	advantage_ii: {
		name: 'Advantage II',
		backgroundColor: '#007040',
		lightBackgroundColor: 'default',
	},
	advantage_ii_for_cats: {
		name: 'Advantage II for Cats',
		backgroundColor: '#007040',
		lightBackgroundColor: '#e5f0eb',
	},
	advantage_ii_for_dogs: {
		name: 'Advantage II for Dogs',
		backgroundColor: '#007040',
		lightBackgroundColor: '#e5f0eb',
	},
	advantage_multi: {
		name: 'Advantage Multi',
		backgroundColor: '#f18e00',
		lightBackgroundColor: '#fef3e5',
	},
	advantage_multi_advocate: {
		name: 'Advantage Multi (Advocate)',
		backgroundColor: '#f18e00',
		lightBackgroundColor: 'default',
	},
	advantage_multi_for_cats: {
		name: 'Advantage Multi for Cats',
		backgroundColor: '#f18e00',
		lightBackgroundColor: 'default',
	},
	advantage_multi_for_dogs: {
		name: 'Advantage Multi for Dogs',
		backgroundColor: '#f18e00',
		lightBackgroundColor: 'default',
	},
	advantage_max_3: {
		name: 'Advantage Max 3',
		backgroundColor: '#a7042a',
		lightBackgroundColor: 'default',
	},
	advanthome: {
		name: 'Advanthome',
		backgroundColor: '#b10431',
		lightBackgroundColor: '#f7e5ea',
	},
	advantix: {
		name: 'Advantix',
		backgroundColor: '#b10431',
		lightBackgroundColor: '#f9e5eb',
	},
	onsior_advantix_light: {
		name: 'Onsior Advantix Light',
		backgroundColor: '#f9e5eb',
		lightBackgroundColor: 'default',
	},
	advantus: {
		name: 'Advantus',
		backgroundColor: '#008752',
		lightBackgroundColor: '#e5f3ed',
	},
	advocate: {
		name: 'Advocate',
		backgroundColor: '#EF7D00',
		lightBackgroundColor: '#EF7D00',
	},
	advocate_orange: {
		name: 'Advocate Orange',
		backgroundColor: '#E57200',
		lightBackgroundColor: '#E57200',
	},
	agita: {
		name: 'Agita',
		backgroundColor: '#7ea0c4',
		lightBackgroundColor: 'default',
	},
	agita_10g: {
		name: 'Agita 10G',
		backgroundColor: '#7ea0c4',
		lightBackgroundColor: 'default',
	},
	agita_10wg: {
		name: 'Agita 10WG',
		backgroundColor: '#7ea0c4',
		lightBackgroundColor: 'default',
	},
	agita_flybait: {
		name: 'Agita Flybait',
		backgroundColor: '#7ea0c4',
		lightBackgroundColor: 'default',
	},
	agrovet: {
		name: 'Agrovet',
		backgroundColor: '#0476b0',
		lightBackgroundColor: 'default',
	},
	alenza: {
		name: 'Alenza',
		backgroundColor: '#249390',
		lightBackgroundColor: '#e9f4f4',
	},
	asuntol: {
		name: 'Asuntol',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	atopica: {
		name: 'Atopica',
		backgroundColor: '#25076a',
		lightBackgroundColor: 'default',
	},
	attivo_tabs: {
		name: 'Attivo® Tabs',
		backgroundColor: '#952a29',
		lightBackgroundColor: 'default',
	},
	avipro: {
		name: 'Avipro',
		backgroundColor: '#da2128',
		lightBackgroundColor: 'default',
	},
	avipro_grey: {
		name: 'Avipro Grey',
		backgroundColor: '#929292',
		lightBackgroundColor: 'default',
	},
	avipro_red: {
		name: 'Avipro Red',
		backgroundColor: '#d51317',
		lightBackgroundColor: 'default',
	},
	aviblue_light_blue: {
		name: 'AviBlue Light Blue',
		backgroundColor: '#41c0f0',
		lightBackgroundColor: 'default',
	},
	aviblue_mid_blue: {
		name: 'AviBlue Mid Blue',
		backgroundColor: '#0078BF',
		lightBackgroundColor: 'default',
	},
	aviblue_dark_blue: {
		name: 'AviBlue Dark Blue',
		backgroundColor: '#073F65',
		lightBackgroundColor: 'default',
	},
	avipro_109_se4_concentrate: {
		name: 'Avipro 109 SE4 Concentrate',
		backgroundColor: '#da2128',
		lightBackgroundColor: 'default',
	},
	avipro_329_nd_ib2_se4_concentrate: {
		name: 'Avipro 329 ND-IB2-SE4 Concentrate',
		backgroundColor: '#da2128',
		lightBackgroundColor: 'default',
	},
	avipro_megan_egg: {
		name: 'Avipro Megan Egg',
		backgroundColor: '#da2128',
		lightBackgroundColor: 'default',
	},
	avipro_megan_vac_1: {
		name: 'Avipro Megan Vac 1',
		backgroundColor: '#da2128',
		lightBackgroundColor: 'default',
	},
	avipro_nd_ib_ibd_reo: {
		name: 'Avipro ND-IB-IBD-REO',
		backgroundColor: '#da2128',
		lightBackgroundColor: 'default',
	},
	avipro_salmonella: {
		name: 'Avipro Salmonella',
		backgroundColor: '#da2128',
		lightBackgroundColor: 'default',
	},
	avipro_thymovac: {
		name: 'Avipro Thymovac',
		backgroundColor: '#da2128',
		lightBackgroundColor: 'default',
	},
	bactocell: {
		name: 'Bactocell',
		backgroundColor: '#0db14b',
		lightBackgroundColor: 'default',
	},
	baseline: {
		name: 'Baseline',
		backgroundColor: '#db3168',
		lightBackgroundColor: 'default',
	},
	bovaer: {
		name: 'Bovaer',
		backgroundColor: '#027d50',
		lightBackgroundColor: 'default',
	},
	baycox: {
		name: 'Baycox',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	baycox_5_multi: {
		name: 'Baycox 5% / Multi',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	baycox_iron_injection: {
		name: 'Baycox Iron Injection',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	baycox_iron_oral: {
		name: 'Baycox Iron Oral',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	bayticol_pour_on: {
		name: 'Bayticol Pour On',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	baytril: {
		name: 'Baytril',
		backgroundColor: '#c52e5a',
		lightBackgroundColor: 'default',
	},
	baytril_0_5: {
		name: 'Baytril 0.5%',
		backgroundColor: '#c52e5a',
		lightBackgroundColor: 'default',
	},
	baytril_10_injection: {
		name: 'Baytril 10% Injection',
		backgroundColor: '#c52e5a',
		lightBackgroundColor: 'default',
	},
	baytril_2_5_oral: {
		name: 'Baytril 2.5% Oral',
		backgroundColor: '#c52e5a',
		lightBackgroundColor: 'default',
	},
	baytril_5_injection: {
		name: 'Baytril 5% Injection',
		backgroundColor: '#c52e5a',
		lightBackgroundColor: 'default',
	},
	baytril_100: {
		name: 'Baytril 100',
		backgroundColor: '#008f87',
		lightBackgroundColor: 'default',
	},
	baytril_flavour_compresse_15mg: {
		name: 'Baytril Flavour Compresse 15 Mg',
		backgroundColor: '#9eaf23',
		lightBackgroundColor: 'default',
	},
	baytril_flavour_compresse_150mg: {
		name: 'Baytril Flavour Compresse 150Mg',
		backgroundColor: '#a60e1e',
		lightBackgroundColor: 'default',
	},
	baytril_flavour_compresse_250mg: {
		name: 'Baytril Flavour Compresse 250Mg',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	baytril_flavour_compresse_50mg: {
		name: 'Baytril Flavour Compresse 50Mg',
		backgroundColor: '#132d7b',
		lightBackgroundColor: 'default',
	},
	baytril_flavour_sospensione_orale_per_gatti: {
		name: 'Baytril Flavour Sospensione Orale Per Gatti',
		backgroundColor: '#5186c2',
		lightBackgroundColor: 'default',
	},
	baytril_max: {
		name: 'Baytril Max',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	baytril_otic: {
		name: 'Baytril Otic',
		backgroundColor: '#5a2c72',
		lightBackgroundColor: 'default',
	},
	baytril_soluzione_iniettabile_25mg_ml: {
		name: 'Baytril Soluzione Iniettabile 25Mg/Ml',
		backgroundColor: '#005d9d',
		lightBackgroundColor: 'default',
	},
	bewormready: {
		name: 'Bewormready',
		backgroundColor: '#fc019d',
		lightBackgroundColor: 'default',
	},
	bexacat: {
		name: 'Bexacat',
		backgroundColor: '#CC27B0',
		lightBackgroundColor: 'default',
	},
	bexacat_orange: {
		name: 'Bexacat Orange',
		backgroundColor: '#FF9E18',
		lightBackgroundColor: 'default',
		defaultStyle: 'bg-[#FF9E18] text-white',
		collapsed: 'bg-[#cfcbca] text-white hover:bg-[#a19c9c]',
		selected: 'bg-[#FF9E18] text-white hover:bg-[#C25C00]',
	},
	bexacat_dark_grey: {
		name: 'Bexacat Dark Grey',
		backgroundColor: '#262626',
		lightBackgroundColor: 'default',
	},
	bexacat_bright_purple: {
		name: 'Bexacat Bright Purple',
		backgroundColor: '#C724B1',
		lightBackgroundColor: 'default',
		defaultStyle: 'bg-[#C724B1] text-white',
		collapsed: 'bg-[#cfcbca] text-white hover:bg-[#a19c9c]',
		selected: 'bg-[#C724B1] text-white hover:bg-[#ac1798]',
	},
	bexacat_purple_accent: {
		name: 'Bexacat Purple Accent',
		backgroundColor: '#b24399',
		lightBackgroundColor: 'default',
		defaultStyle: 'bg-[#b24399] text-white',
		collapsed: 'bg-[#cfcbca] text-white hover:bg-[#a19c9c]',
		selected: 'bg-[#b24399] text-white hover:bg-[#983c83]',
	},
	bolfo: {
		name: 'Bolfo',
		backgroundColor: '#e3000f',
		lightBackgroundColor: '#fce5e7',
	},
	bovine_ecolizer: {
		name: 'Bovine Ecolizer',
		backgroundColor: '#691f74',
		lightBackgroundColor: 'default',
	},
	bovine_pili_shield: {
		name: 'Bovine Pili Shield',
		backgroundColor: '#691f74',
		lightBackgroundColor: 'default',
	},
	bronch: {
		name: 'Bronchishield',
		backgroundColor: '#25076A',
		lightBackgroundColor: '#B6BF00',
	},
	calcio_ad3_plus_tabs: {
		name: 'Calcio AD3 Plus Tabs',
		backgroundColor: '#e4007d',
		lightBackgroundColor: 'default',
	},
	capstar: {
		name: 'Capstar',
		backgroundColor: '#00633E',
		lightBackgroundColor: 'default',
	},
	catosal: {
		name: 'Catosal',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	coforta: {
		name: 'Coforta',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	catosal_coforta: {
		name: 'Catosal / Coforta',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	chlorhexl_derm: {
		name: 'Chlorhexl Derm',
		backgroundColor: '#b31d2d',
		lightBackgroundColor: '#f7e8ea',
	},
	claro: {
		name: 'Claro',
		backgroundColor: '#510c76',
		lightBackgroundColor: '#ede6f1',
	},
	claro_neptra: {
		name: 'Claro / Neptra',
		backgroundColor: '#522873',
		lightBackgroundColor: 'default',
	},
	clavobay_250mg: {
		name: 'Clavobay 250Mg',
		backgroundColor: '#7a1971',
		lightBackgroundColor: 'default',
	},
	clavobay_500mg: {
		name: 'Clavobay 500Mg',
		backgroundColor: '#ae6a14',
		lightBackgroundColor: 'default',
	},
	clavobay_50mg: {
		name: 'Clavobay 50Mg',
		backgroundColor: '#98bc25',
		lightBackgroundColor: 'default',
	},
	clean_up_2: {
		name: 'Clean Up II',
		backgroundColor: '#92C050',
		lightBackgroundColor: 'default',
	},
	clinacox: {
		name: 'Clinacox',
		backgroundColor: '#e5e1e5',
		lightBackgroundColor: 'default',
	},
	clik_light_blue: {
		name: 'CLiK Light Blue',
		backgroundColor: '#0C78BD',
		lightBackgroundColor: 'default',
	},
	clik_dark_blue: {
		name: 'CLiK Dark Blue',
		backgroundColor: '#1F3560',
		lightBackgroundColor: 'default',
	},
	clik_yellow: {
		name: 'CLiK Yellow',
		backgroundColor: '#DB9300',
		lightBackgroundColor: 'default',
	},
	clostratox: {
		name: 'Clostratox',
		backgroundColor: '#006646',
		lightBackgroundColor: 'default',
	},
	clostri_shield: {
		name: 'Clostri Shield',
		backgroundColor: '#006646',
		lightBackgroundColor: 'default',
	},
	clostridium_perfringens: {
		name: 'Clostridium Perfringens',
		backgroundColor: '#006646',
		lightBackgroundColor: 'default',
	},
	coban_: {
		name: 'Coban',
		backgroundColor: '#ffd200',
		lightBackgroundColor: 'default',
	},
	coban: {
		name: 'Coban',
		backgroundColor: '#ffd200',
		lightBackgroundColor: 'default',
	},
	coliprotec_teal: {
		name: 'Coliprotec Teal',
		backgroundColor: '#0081a3',
		lightBackgroundColor: 'default',
	},
	comfortis: {
		name: 'Comfortis',
		backgroundColor: '#f03127',
		lightBackgroundColor: 'default',
	},
	correlink: {
		name: 'Correlink',
		backgroundColor: '#133156',
		lightBackgroundColor: 'default',
	},
	comfortis_for_cats: {
		name: 'Comfortis for Cats',
		backgroundColor: '#f03127',
		lightBackgroundColor: 'default',
	},
	comfortis_for_dogs: {
		name: 'Comfortis for Dogs',
		backgroundColor: '#f03127',
		lightBackgroundColor: 'default',
	},
	component_with_tylan: {
		name: 'Component With Tylan',
		backgroundColor: '#004990',
		lightBackgroundColor: 'default',
	},
	compudose: {
		name: 'Compudose',
		backgroundColor: '#ee3124',
		lightBackgroundColor: 'default',
	},
	cydectin: {
		name: 'Cydectin',
		backgroundColor: '#5C4586',
		lightBackgroundColor: 'default',
	},
	onsior_cool_gray_6c: {
		name: 'Onsior Cool Gray 6 C',
		backgroundColor: '#a7a8aa',
		lightBackgroundColor: 'default',
	},
	onsior_cool_gray_10: {
		name: ' Onsior Cool Gray 10',
		backgroundColor: '#63666a',
		lightBackgroundColor: 'default',
	},
	cosabody: {
		name: 'Cosabody',
		backgroundColor: '#4c104e',
		lightBackgroundColor: 'default',
	},
	covalzin: {
		name: 'Covalzin',
		backgroundColor: '#0072ce',
		lightBackgroundColor: 'default',
	},
	credelio: {
		name: 'Credelio',
		backgroundColor: '#00843D',
		lightBackgroundColor: 'default',
	},
	credelio_plus: {
		name: 'Credelio Plus',
		backgroundColor: '#006341',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_guard_dog: {
		name: 'Credelio Quattro Guard Dog',
		backgroundColor: '#0F3320',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_hunter_green: {
		name: 'Credelio Quattro Hunter Green',
		backgroundColor: '#00643C',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_grass_green: {
		name: 'Credelio Quattro Grass Green',
		backgroundColor: '#009548',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_tennis_ball_green: {
		name: 'Credelio Quattro Tennis Ball Green',
		backgroundColor: '#80BB4F',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_park_green: {
		name: 'Credelio Quattro Park Green',
		backgroundColor: '#94CE95',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_golden: {
		name: 'Credelio Quattro Golden',
		backgroundColor: '#F68A33',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_milk_bone: {
		name: 'Credelio Quattro Milk Bone',
		backgroundColor: '#EDECDE',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_frisbee: {
		name: 'Credelio Quattro Frisbee',
		backgroundColor: '#EC008C',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_sunny_day: {
		name: 'Credelio Quattro Sunny Day',
		backgroundColor: '#EAAC18',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_sky_blue: {
		name: 'Credelio Quattro Sky Blue',
		backgroundColor: '#0099D8',
		lightBackgroundColor: 'default',
	},
	onsior_dark_blue: {
		name: 'Onsior Dark Blue',
		backgroundColor: '#003594',
		lightBackgroundColor: 'default',
	},
	onsior_dark_gray: {
		name: 'Onsior Dark Gray',
		backgroundColor: '#2c2a29',
		lightBackgroundColor: 'default',
	},
	onsior_dark_red: {
		name: 'Onsior Dark Red',
		backgroundColor: '#9d2235',
		lightBackgroundColor: 'default',
	},
	onsior_dark_violet: {
		name: 'Onsior Dark Violet',
		backgroundColor: '#3c1053',
		lightBackgroundColor: 'default',
	},
	dasuquin_powder_in: {
		name: 'Dasuquin Powder-In',
		backgroundColor: '#78be20',
		lightBackgroundColor: 'default',
	},
	dasuquin_tablet: {
		name: 'Dasuquin Tablet',
		backgroundColor: '#78be20',
		lightBackgroundColor: 'default',
	},
	deramaxx: {
		name: 'Deramaxx',
		backgroundColor: '#0048e0',
		lightBackgroundColor: 'default',
	},
	denagard: {
		name: 'Denagard',
		backgroundColor: '#1d3d7c',
		lightBackgroundColor: 'default',
	},
	denagard_12_5_water_soluble_ws: {
		name: 'Denagard 12.5% Water Soluble',
		backgroundColor: '#1d3d7c',
		lightBackgroundColor: 'default',
	},
	denagard_45_granulate: {
		name: 'Denagard 45% Granulate',
		backgroundColor: '#1d3d7c',
		lightBackgroundColor: 'default',
	},
	denagard_injection: {
		name: 'Denagard Injection',
		backgroundColor: '#1d3d7c',
		lightBackgroundColor: 'default',
	},
	denagard10_premix: {
		name: 'Denagard10 Premix',
		backgroundColor: '#1d3d7c',
		lightBackgroundColor: 'default',
	},
	dog_ear_infections: {
		name: 'Dog Ear Infections',
		backgroundColor: '#500778',
		lightBackgroundColor: '#ede6f1',
	},
	droncit_red: {
		name: 'Droncit Red',
		backgroundColor: '#af2a46',
		lightBackgroundColor: 'default',
	},
	dronspot: {
		name: 'Dronspot',
		backgroundColor: '#49a923',
		lightBackgroundColor: '#ecf6e9',
	},
	drontal: {
		name: 'Drontal',
		backgroundColor: '#49a923',
		lightBackgroundColor: '#dceddb',
	},
	drontal_plus: {
		name: 'Drontal Plus',
		backgroundColor: '#572c83',
		lightBackgroundColor: '#eee9f2',
	},
	duramune_lyme: {
		name: 'Duramune Lyme',
		backgroundColor: '#2b529b',
		lightBackgroundColor: 'default',
	},
	dvm_daily_soft_chews: {
		name: 'DVM Daily Soft Chews',
		backgroundColor: '#0071ce',
		lightBackgroundColor: '#e5f1fa',
	},
	dvm_feline_joint_gel: {
		name: 'DVM Feline Joint Gel',
		backgroundColor: '#d33a2a',
		lightBackgroundColor: '#fbebe9',
	},
	elancoban: {
		name: 'Elancoban',
		backgroundColor: '#ffd200',
		lightBackgroundColor: 'default',
	},
	elanco_grey: {
		name: 'Elanco Grey',
		backgroundColor: '#7F7F7F',
		lightBackgroundColor: 'default',
	},
	elector: {
		name: 'Elector',
		backgroundColor: '#e7ad36',
		lightBackgroundColor: 'default',
	},
	elura: {
		name: 'Elura',
		backgroundColor: '#ab1369',
		lightBackgroundColor: 'default',
	},
	endurosyn: {
		name: 'Endurosyn',
		backgroundColor: '#006937',
		lightBackgroundColor: '#E5F0EB',
	},
	encore: {
		name: 'Encore',
		backgroundColor: '#ee3124',
		lightBackgroundColor: 'default',
	},
	entyce: {
		name: 'Entyce',
		backgroundColor: '#440099',
		lightBackgroundColor: 'default',
	},
	ethicon: {
		name: 'Ethicon',
		backgroundColor: '#f30617',
		lightBackgroundColor: 'default',
	},
	evosure: {
		name: 'Evosure',
		backgroundColor: '#e56606',
		lightBackgroundColor: 'default',
	},
	experior: {
		name: 'Experior',
		backgroundColor: '#77c043',
		lightBackgroundColor: 'default',
	},
	feedaid: {
		name: 'FeedAid',
		backgroundColor: '#729786',
		lightBackgroundColor: 'default',
	},
	fel_o_guard: {
		name: 'Fel-O-Guard',
		backgroundColor: '#004b8d',
		lightBackgroundColor: 'default',
	},
	fel_o_vax: {
		name: 'Fel-O-Vax',
		backgroundColor: '#004b8d',
		lightBackgroundColor: 'default',
	},
	fleegard: {
		name: 'Fleegard',
		backgroundColor: '#da1715',
		lightBackgroundColor: 'default',
	},
	flubenvet: {
		name: 'Flubenvet',
		backgroundColor: '#788e1d',
		lightBackgroundColor: 'default',
	},
	formalife_fermenti_lattice: {
		name: 'Formalife Fermenti Lattice',
		backgroundColor: '#005897',
		lightBackgroundColor: 'default',
	},
	fortekor: {
		name: 'Fortekor',
		backgroundColor: '#f21740',
		lightBackgroundColor: 'default',
	},
	fortekor_plus: {
		name: 'Fortekor Plus',
		backgroundColor: '#f21740',
		lightBackgroundColor: 'default',
	},
	free_form: {
		name: 'Free Form',
		backgroundColor: '#27a9e1',
		lightBackgroundColor: '#e9f6fc',
	},
	full_value_pork_primary_blue: {
		name: 'Full Value Pork Primary Blue',
		backgroundColor: '#004267',
		lightBackgroundColor: 'default',
	},
	full_value_pork_secondary_blue: {
		name: 'Full Value Pork Secondary Blue',
		backgroundColor: '#30a9d7',
		lightBackgroundColor: 'default',
	},
	fusogard: {
		name: 'Fusogard',
		backgroundColor: '#000b8c',
		lightBackgroundColor: 'default',
	},
	galliprant: {
		name: 'Galliprant',
		backgroundColor: '#bf0d3e',
		lightBackgroundColor: 'default',
	},
	galliprant_yellow: {
		name: 'Galliprant Yellow',
		backgroundColor: '#ffc600',
		lightBackgroundColor: 'default',
	},
	galliprant_red: {
		name: 'Galliprant Red',
		backgroundColor: '#d11947',
		lightBackgroundColor: 'default',
	},
	gallipro_fit_yellow: {
		name: 'Gallipro Fit yellow',
		backgroundColor: '#FBBA00',
		lightBackgroundColor: 'default',
	},
	gallipro_fit_orange: {
		name: 'Gallipro Fit orange',
		backgroundColor: '#EF7900',
		lightBackgroundColor: 'default',
	},
	gallipro_fit_green: {
		name: 'Gallipro Fit green',
		backgroundColor: '#9EB184',
		lightBackgroundColor: 'default',
	},
	gallipro_fit_darkblue: {
		name: 'Gallipro Fit darkblue',
		backgroundColor: '#142C46',
		lightBackgroundColor: 'default',
	},
	ganaseg: {
		name: 'Ganaseg',
		backgroundColor: '#006c68',
		lightBackgroundColor: 'default',
	},
	guardian: {
		name: 'Guardian',
		backgroundColor: '#dc0a21',
		lightBackgroundColor: 'default',
	},
	heifermax: {
		name: 'Heifermax',
		backgroundColor: '#ce0058',
		lightBackgroundColor: 'default',
	},
	hemicell: {
		name: 'Hemicell',
		backgroundColor: '#30b19d',
		lightBackgroundColor: 'default',
	},
	hemicell_red: {
		name: 'Hemicell Red',
		backgroundColor: '#b32b2e',
		lightBackgroundColor: 'default',
	},
	hemicell_dry: {
		name: 'Hemicell Dry',
		backgroundColor: '#30b19d',
		lightBackgroundColor: 'default',
	},
	hemicell_ht: {
		name: 'Hemicell HT',
		backgroundColor: '#a3262c',
		lightBackgroundColor: 'default',
	},
	hemicell_liquid: {
		name: 'Hemicell Liquid',
		backgroundColor: '#a3262c',
		lightBackgroundColor: 'default',
	},
	hinocare_dailycare: {
		name: 'Hinocare Dailycare',
		backgroundColor: '#8a0317',
		lightBackgroundColor: 'default',
	},
	hinocare_for_professional_skincare_lotion: {
		name: 'Hinocare For Professional Skincare Lotion',
		backgroundColor: '#0047bb',
		lightBackgroundColor: 'default',
	},
	hinocare_for_professional_skincare_shampoo: {
		name: 'Hinocare For Professional Skincare Shampoo',
		backgroundColor: '#0047bb',
		lightBackgroundColor: 'default',
	},
	htsi: {
		name: 'HTSI',
		backgroundColor: '#004268',
		lightBackgroundColor: '#e5f0ec',
	},
	hylyt: {
		name: 'HyLyt',
		backgroundColor: '#026747',
		lightBackgroundColor: '#e5f0ec',
	},
	increxxa: {
		name: 'Increxxa',
		backgroundColor: '#4c12a1',
		lightBackgroundColor: 'default',
	},
	increxxa_25: {
		name: 'Increxxa 25',
		backgroundColor: '#0057b7',
		lightBackgroundColor: 'default',
	},
	interceptor_plus: {
		name: 'Interceptor Plus',
		backgroundColor: '#ffdd3d',
		lightBackgroundColor: 'default',
	},
	inteprity: {
		name: 'Inteprity',
		backgroundColor: '#b25d27',
		lightBackgroundColor: 'default',
	},
	joki_dent_classic: {
		name: 'Joki Dent Classic',
		backgroundColor: '#00a49f',
		lightBackgroundColor: 'default',
	},
	joki_dent_fresh: {
		name: 'Joki Dent Fresh',
		backgroundColor: '#00a49f',
		lightBackgroundColor: 'default',
	},
	joki_dent_oral_care_gatto: {
		name: 'Joki Dent Oral Care Gatto',
		backgroundColor: '#00a49f',
		lightBackgroundColor: 'default',
	},
	joki_dent_vegetal: {
		name: 'Joki Dent Vegetal',
		backgroundColor: '#00a49f',
		lightBackgroundColor: 'default',
	},
	k9_advantix_ii: {
		name: 'K9 Advantix II',
		backgroundColor: '#b20838',
		lightBackgroundColor: 'default',
	},
	kavault: {
		name: 'Kavault',
		backgroundColor: '#996633',
		lightBackgroundColor: 'default',
	},
	ketotest: {
		name: 'Ketotest',
		backgroundColor: '#0072ce',
		lightBackgroundColor: 'default',
	},
	kexxtone: {
		name: 'Kexxtone',
		backgroundColor: '#FFD000',
		lightBackgroundColor: 'default',
	},
	kinetomax: {
		name: 'Kinetomax',
		backgroundColor: '#105781',
		lightBackgroundColor: 'default',
	},
	kltix: {
		name: 'Kiltix Pink',
		backgroundColor: '#cd007d',
		lightBackgroundColor: 'default',
	},
	kiltix: {
		name: 'Kiltix Teal',
		backgroundColor: '#0094bc',
		lightBackgroundColor: '#fae7f2',
	},
	lactoqull: {
		name: 'Lactoqull',
		backgroundColor: '#009560',
		lightBackgroundColor: '#e5f4ef',
	},
	lanirat: {
		name: 'Lanirat',
		backgroundColor: '#077a77',
		lightBackgroundColor: 'default',
	},
	larvadex: {
		name: 'Larvadex',
		backgroundColor: '#9f4879',
		lightBackgroundColor: 'default',
	},
	lepto_shield: {
		name: 'Lepto Shield',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	levucell_sb: {
		name: 'Levucell SB',
		backgroundColor: '#42aad6',
		lightBackgroundColor: 'default',
	},
	onsior_lime_green: {
		name: 'Onsior Lime Green',
		backgroundColor: '#00b140',
		lightBackgroundColor: 'default',
	},
	light_gray: {
		name: 'Light Gray',
		backgroundColor: '#f2f2f2',
		lightBackgroundColor: 'default',
	},
	lipinate: {
		name: 'Lipinate',
		backgroundColor: '#464c3e',
		lightBackgroundColor: 'default',
	},
	loncor: {
		name: 'Loncor',
		backgroundColor: '#f1c631',
		lightBackgroundColor: 'default',
	},
	malaseb: {
		name: 'Malaseb',
		backgroundColor: '#b31d2d',
		lightBackgroundColor: '#F7E8EA',
	},
	masterguard: {
		name: 'Masterguard',
		backgroundColor: '#b9ab97',
		lightBackgroundColor: 'default',
	},
	maxiban_: {
		name: 'Maxiban',
		backgroundColor: '#d31245',
		lightBackgroundColor: 'default',
	},
	maxiban: {
		name: 'Maxiban',
		backgroundColor: '#d31145',
		lightBackgroundColor: 'default',
	},
	micotil: {
		name: 'Micotil',
		backgroundColor: '#13b5ea',
		lightBackgroundColor: 'default',
	},
	milbemax: {
		name: 'Milbemax',
		backgroundColor: '#004e8f',
		lightBackgroundColor: '#83AFD6',
	},
	milbemax_blue: {
		name: 'Milbemax Blue',
		backgroundColor: '#004e8f',
		lightBackgroundColor: '#83AFD6',
	},
	milbemax_red: {
		name: 'Milbemax Red',
		backgroundColor: '#B10035',
		lightBackgroundColor: '#F9E5EB',
	},
	monteban: {
		name: 'Monteban',
		backgroundColor: '#009b7a',
		lightBackgroundColor: 'default',
	},
	murnil_plus_tabs: {
		name: 'Murnil Plus Tabs',
		backgroundColor: '#00683b',
		lightBackgroundColor: 'default',
	},
	myco_shiled: {
		name: 'Myco Shiled',
		backgroundColor: '#fec860',
		lightBackgroundColor: 'default',
	},
	neo_calcio_ad3_polvere: {
		name: 'Neo Calcio AD3 Polvere',
		backgroundColor: '#e4007d',
		lightBackgroundColor: 'default',
	},
	neomineralsalz_reintegrante: {
		name: 'Neomineralsalz Reintegrante',
		backgroundColor: '#007599',
		lightBackgroundColor: 'default',
	},
	neporex: {
		name: 'Neporex',
		backgroundColor: '#618376',
		lightBackgroundColor: 'default',
	},
	neptra_green: {
		name: 'Neptra green',
		backgroundColor: '#c7d530',
		lightBackgroundColor: 'default',
	},
	nocita: {
		name: 'Nocita',
		backgroundColor: '#0097a0',
		lightBackgroundColor: 'default',
	},
	nuplura_ph: {
		name: 'Nuplura PH',
		backgroundColor: '#a4cf5f',
		lightBackgroundColor: 'default',
	},
	nuplura_ph_plus_5_primary: {
		name: 'Nuplura PH+5 Primary',
		backgroundColor: '#a1d060',
		lightBackgroundColor: 'default',
	},
	nuplura_ph_plus_5_secondary: {
		name: 'Nuplura PH+5 Secondary',
		backgroundColor: '#8b8c90',
		lightBackgroundColor: 'default',
	},
	onsior: {
		name: 'Onsior',
		backgroundColor: '#00a9ce',
		lightBackgroundColor: 'default',
	},
	optaflexx: {
		name: 'Optaflexx',
		backgroundColor: '#00a18e',
		lightBackgroundColor: 'default',
	},
	otlrinse: {
		name: 'OtlRinse',
		backgroundColor: '#1b81bb',
		lightBackgroundColor: '#e8f2f8',
	},
	otodog: {
		name: 'Otodog',
		backgroundColor: '#007bbf',
		lightBackgroundColor: 'default',
	},
	panalog: {
		name: 'Panalog',
		backgroundColor: '#003ca6',
		lightBackgroundColor: 'default',
	},
	para_shield: {
		name: 'Para Shield',
		backgroundColor: '#b6363a',
		lightBackgroundColor: 'default',
	},
	parvo: {
		name: 'Parvo',
		backgroundColor: '#2B71B8',
		lightBackgroundColor: 'default',
	},
	parvo_shiled_l5e: {
		name: 'Parvo Shiled L5E',
		backgroundColor: '#7f2629',
		lightBackgroundColor: 'default',
	},
	percorten_v: {
		name: 'Percorten-V',
		backgroundColor: '#007663',
		lightBackgroundColor: 'default',
	},
	pet_protect_red: {
		name: 'Pet Protect - Red',
		backgroundColor: '#F9423A',
		lightBackgroundColor: 'default',
	},
	pet_protect_green: {
		name: 'Pet Protect - Green',
		backgroundColor: '#13863D',
		lightBackgroundColor: 'default',
	},
	pet_protect_blue: {
		name: 'Pet Protect - Blue',
		backgroundColor: '#49B2E6',
		lightBackgroundColor: 'default',
	},
	pet_protect_skin: {
		name: 'Pet Protect Skin',
		backgroundColor: '#25B0E7',
		lightBackgroundColor: 'default',
	},
	pet_protect_calm: {
		name: 'Pet Protect Calm',
		backgroundColor: '#C05694',
		lightBackgroundColor: 'default',
	},
	pet_protect_allergy: {
		name: 'Pet Protect Allergy',
		backgroundColor: '#70B925',
		lightBackgroundColor: 'default',
	},
	civ: {
		name: 'CIV',
		backgroundColor: '#CFB62E',
		lightBackgroundColor: 'default',
	},
	elmaro_navy_blue: {
		name: 'Elmaro Navy Blue',
		backgroundColor: '#00457f',
		lightBackgroundColor: 'default',
	},
	elmaro_pink: {
		name: 'Elmaro Pink',
		backgroundColor: '#eb7bae',
		lightBackgroundColor: 'default',
	},
	elmaro_yellow: {
		name: 'Elmaro Yellow',
		backgroundColor: '#fbba00',
		lightBackgroundColor: 'default',
	},
	pili_shield_plus_c: {
		name: 'Pili Shield +C',
		backgroundColor: '#7f2629',
		lightBackgroundColor: 'default',
	},
	pillpocket: {
		name: 'Pillpocket',
		backgroundColor: '#046a38',
		lightBackgroundColor: 'default',
	},
	pinkeye_shield_xt4: {
		name: 'Pinkeye Shield XT4',
		backgroundColor: '#df1683',
		lightBackgroundColor: 'default',
	},
	pradalex: {
		name: 'Pradalex',
		backgroundColor: '#26d07c',
		lightBackgroundColor: 'default',
	},
	prefender: {
		name: 'Profender',
		backgroundColor: '#FEC057',
		lightBackgroundColor: '#fff9ee',
	},
	prevacent_prrs: {
		name: 'Prevacent PRRS',
		backgroundColor: '#d80516',
		lightBackgroundColor: 'default',
	},
	primapappa_cucciolo: {
		name: 'Primapappa Cucciolo',
		backgroundColor: '#e75c73',
		lightBackgroundColor: 'default',
	},
	primapappa_gattino: {
		name: 'Primapappa Gattino',
		backgroundColor: '#e75c73',
		lightBackgroundColor: 'default',
	},
	primolatte_cucciolo: {
		name: 'Primolatte Cucciolo',
		backgroundColor: '#00a2de',
		lightBackgroundColor: 'default',
	},
	primolatte_gattino: {
		name: 'Primolatte Gattino',
		backgroundColor: '#00a2de',
		lightBackgroundColor: 'default',
	},
	proteck: {
		name: 'Proteck',
		backgroundColor: '#cc9000',
		lightBackgroundColor: 'default',
	},
	pulmotil: {
		name: 'Pulmotil',
		backgroundColor: '#b92f92',
		lightBackgroundColor: 'default',
	},
	pulmotil_100_pre_mix: {
		name: 'Pulmotil 100 Pre-Mix',
		backgroundColor: '#0093d1',
		lightBackgroundColor: 'default',
	},
	pulmotil_40_pre_mix: {
		name: 'Pulmotil 40 Pre-Mix',
		backgroundColor: '#0093d1',
		lightBackgroundColor: 'default',
	},
	pulmotil_ac: {
		name: 'Pulmotil AC',
		backgroundColor: '#bc2584',
		lightBackgroundColor: 'default',
	},
	pulmotil_premix: {
		name: 'Pulmotil Premix',
		backgroundColor: '#b92f92',
		lightBackgroundColor: 'default',
	},
	quad_dewormer: {
		name: 'Quad Dewormer',
		backgroundColor: '#9c921e',
		lightBackgroundColor: '#f5f4e8',
	},
	quick_bayt: {
		name: 'Quick Bayt',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	quick_shield: {
		name: 'Quick Shield',
		backgroundColor: '#5c6670',
		lightBackgroundColor: 'default',
	},
	quellin: {
		name: 'Quellin',
		backgroundColor: '#002b54',
		lightBackgroundColor: 'default',
	},
	rabvac: {
		name: 'Rabvac',
		backgroundColor: '#004b8d',
		lightBackgroundColor: 'default',
	},
	rellef: {
		name: 'Rellef',
		backgroundColor: '#0c8495',
		lightBackgroundColor: '#e6f2f4',
	},
	remend: {
		name: 'Remend',
		backgroundColor: '#462777',
		lightBackgroundColor: '#ece9f1',
	},
	reprostar: {
		name: 'Reprostar',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	rhini_shield: {
		name: 'Rhini Shield',
		backgroundColor: '#009383',
		lightBackgroundColor: 'default',
	},
	onsior_rhodamine_red: {
		name: 'Onsior Rhodamine Red',
		backgroundColor: '#e10098',
		lightBackgroundColor: 'default',
	},
	rimuovipelo_gatto: {
		name: 'Rimuovipelo Gatto',
		backgroundColor: '#00694f',
		lightBackgroundColor: 'default',
	},
	rumensin: {
		name: 'Rumensin',
		backgroundColor: '#f58426',
		lightBackgroundColor: 'default',
	},
	salmonella_360: {
		name: 'Salmonella 360',
		backgroundColor: '#EE7D00',
		lightBackgroundColor: 'default',
	},
	swine_awake: {
		name: 'Swine Awake',
		backgroundColor: '#7b2379',
		lightBackgroundColor: 'default',
	},
	zenrelia: {
		name: 'Zenrelia',
		backgroundColor: '#215447',
		lightBackgroundColor: 'default',
		defaultStyle: 'bg-[#215447] text-white hover:bg-[#74a30e]',
		collapsed: 'bg-[#215447] text-white',
		selected: 'bg-[#91cc12] text-white',
	},
	zenrelia_primary: {
		name: 'Zenrelia Primary',
		backgroundColor: '#215447',
		lightBackgroundColor: 'default',
	},
	zenrelia_secondary: {
		name: 'Zenrelia Secondary',
		backgroundColor: '#91CC12',
		lightBackgroundColor: 'default',
	},
	zenrelia_contrast: {
		name: 'Zenrelia Contrast',
		backgroundColor: '#A68CFA',
		lightBackgroundColor: 'default',
	},
	zenrelia_accent: {
		name: 'Zenrelia Accent',
		backgroundColor: '#c0d29a',
		lightBackgroundColor: 'default',
	},
	zenrelia_sku1: {
		name: 'Zenrelia Sku1',
		backgroundColor: '#618582',
		lightBackgroundColor: 'default',
	},
	zenrelia_sku2: {
		name: 'Zenrelia Sku2',
		backgroundColor: '#8752C7',
		lightBackgroundColor: 'default',
	},
	zenrelia_sku3: {
		name: 'Zenrelia Sku3',
		backgroundColor: '#00A99E',
		lightBackgroundColor: 'default',
	},
	zenrelia_sku4: {
		name: 'Zenrelia Sku4',
		backgroundColor: '#C6B5FF',
		lightBackgroundColor: 'default',
	},
	scour_bos: {
		name: 'Scour Bos',
		backgroundColor: '#6a2875',
		lightBackgroundColor: 'default',
	},
	seresto: {
		name: 'Seresto',
		backgroundColor: '#00597c',
		lightBackgroundColor: 'default',
	},
	skycis: {
		name: 'Skycis',
		backgroundColor: '#fdc27f',
		lightBackgroundColor: 'default',
	},
	somnu_shield: {
		name: 'Somnu Shield',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	standguard: {
		name: 'Standguard',
		backgroundColor: '#ee3124',
		lightBackgroundColor: 'default',
	},
	surmax_100: {
		name: 'Surmax 100',
		backgroundColor: '#996633',
		lightBackgroundColor: 'default',
	},
	surmax_200: {
		name: 'Surmax 200',
		backgroundColor: '#996633',
		lightBackgroundColor: 'default',
	},
	surmax_maxus_inteprity: {
		name: 'Surmax / Maxus / Inteprity',
		backgroundColor: '#996633',
		lightBackgroundColor: 'default',
	},
	synovl_g3: {
		name: 'Synovl G3',
		backgroundColor: '#ee483c',
		lightBackgroundColor: '#fdeceb',
	},
	synovl_g4: {
		name: 'Synovl G4',
		backgroundColor: '#f5854f',
		lightBackgroundColor: '#fef3ed',
	},
	t8_keto: {
		name: 'T8 Keto',
		backgroundColor: '#563393',
		lightBackgroundColor: '#eeeaf4',
	},
	onsior_tangerine: {
		name: 'Onsior Tangerine',
		backgroundColor: '#ffb81c',
		lightBackgroundColor: 'default',
	},
	tanovea: {
		name: 'Tanovea',
		backgroundColor: '#0085ad',
		lightBackgroundColor: 'default',
	},
	tapeworm_dewormer_for_cats: {
		name: 'Tapeworm Dewormer for Cats',
		backgroundColor: '#f27f2d',
		lightBackgroundColor: '#fef2ea',
	},
	tapeworm_dewormer_for_dogs: {
		name: 'Tapeworm Dewormer for Dogs',
		backgroundColor: '#735121',
		lightBackgroundColor: '#f1ede8',
	},
	tempo_one_percent_dust: {
		name: 'Tempo 1% Dust',
		backgroundColor: '#75bc43',
		lightBackgroundColor: 'default',
	},
	tiguvon: {
		name: 'Tiguvon',
		backgroundColor: '#0db14b',
		lightBackgroundColor: 'default',
	},
	tracer: {
		name: 'Tracer',
		backgroundColor: '#ed037c',
		lightBackgroundColor: 'default',
	},
	trifexis: {
		name: 'Trifexis',
		backgroundColor: '#a8ad00',
		lightBackgroundColor: '#f2a900',
	},
	trucan_blue: {
		name: 'Trucan Blue',
		backgroundColor: '#74d7eb',
		lightBackgroundColor: 'default',
	},
	trufel_pink: {
		name: 'Trufel Pink',
		backgroundColor: '#e3c8de',
		lightBackgroundColor: 'default',
	},
	trucid: {
		name: 'Trucid',
		backgroundColor: '#d72027',
		lightBackgroundColor: 'default',
	},
	titanium: {
		name: 'Titanium',
		backgroundColor: '#6a737b',
		lightBackgroundColor: 'default',
	},
	tylan: {
		name: 'Tylan',
		backgroundColor: '#0093d0',
		lightBackgroundColor: 'default',
	},
	tylan_200_injection: {
		name: 'Tylan 200 Injection',
		backgroundColor: '#ee3124',
		lightBackgroundColor: 'default',
	},
	tylan_injection: {
		name: 'Tylan Injection',
		backgroundColor: '#ee3124',
		lightBackgroundColor: 'default',
	},
	tylan_premix: {
		name: 'Tylan Premix',
		backgroundColor: '#0093d0',
		lightBackgroundColor: 'default',
	},
	tylan_soluble: {
		name: 'Tylan Soluble',
		backgroundColor: '#0093d0',
		lightBackgroundColor: 'default',
	},
	ultra_duramune: {
		name: 'ULTRA Duramune',
		backgroundColor: '#499abc',
		lightBackgroundColor: 'default',
	},
	ultra_fel_o_vax: {
		name: 'Ultra Fel-O-Vax',
		backgroundColor: '#f5a3c1',
		lightBackgroundColor: 'default',
	},
	ultra_hybrid: {
		name: 'Ultra Hybrid',
		backgroundColor: '#7276b8',
		lightBackgroundColor: 'default',
	},
	varenzin_red: {
		name: 'Varenzin Red',
		backgroundColor: '#bc2251',
		lightBackgroundColor: 'default',
	},
	varenzin_blue: {
		name: 'Varenzin Blue',
		backgroundColor: '#0056b8',
		lightBackgroundColor: 'default',
	},
	varenzin_purple: {
		name: 'Varenzin Purple',
		backgroundColor: '#6a488e',
		lightBackgroundColor: 'default',
	},
	veraflox: {
		name: 'Veraflox',
		backgroundColor: '#281e69',
		lightBackgroundColor: 'default',
	},
	veraflox_oral_suspension: {
		name: 'Veraflox Oral Suspension',
		backgroundColor: '#272268',
		lightBackgroundColor: 'default',
	},
	vetriderm: {
		name: 'Vetriderm',
		backgroundColor: '#62b51f',
		lightBackgroundColor: 'default',
	},
	vetspon: {
		name: 'Vetspon',
		backgroundColor: '#0073B6',
		lightBackgroundColor: 'default',
	},
	vib_shield: {
		name: 'Vib Shield',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	vira_shield: {
		name: 'Vira Shield',
		backgroundColor: '#e05a28',
		lightBackgroundColor: 'default',
	},
	onsior_vivid_orange: {
		name: 'Onsior Vivid Orange',
		backgroundColor: '#ff671f',
		lightBackgroundColor: 'default',
	},
	zimprova: {
		name: 'Zimprova',
		backgroundColor: '#7a1600',
		lightBackgroundColor: 'default',
	},
	zoashield: {
		name: 'Zoashield',
		backgroundColor: '#092340',
		lightBackgroundColor: 'default',
	},
	zolvix: {
		name: 'Zolvix',
		backgroundColor: '#005043',
		lightBackgroundColor: 'default',
	},
	zolvix_orange: {
		name: 'Zolvix Orange',
		backgroundColor: '#FF5F1F',
		lightBackgroundColor: 'default',
	},
	zorbium: {
		name: 'Zorbium',
		backgroundColor: '#ff64b2',
		lightBackgroundColor: 'default',
	},
	rosa_xo_verme: {
		name: 'Rosa - Xô Verme',
		backgroundColor: '#e82e8a',
		lightBackgroundColor: 'default',
	},
	catosal_metabol: {
		name: 'Catosal Metabol',
		backgroundColor: '#FF3399',
		lightBackgroundColor: 'default',
	},
	befrena_primary_blue: {
		name: 'Befrena Primary Blue',
		backgroundColor: '#0F4597',
		lightBackgroundColor: 'default',
	},
	befrena_accent_green: {
		name: 'Befrena Accent Green',
		backgroundColor: '#8CC63E',
		lightBackgroundColor: 'default',
	},
	befrena_accent_pink: {
		name: 'Befrena Accent Pink',
		backgroundColor: '#E79FC6',
		lightBackgroundColor: 'default',
	},
	zolvix_plus_green: {
		name: 'Zolvix Plus Green',
		backgroundColor: '#105742',
		lightBackgroundColor: 'default',
		defaultStyle: 'bg-[#105742] text-white hover:bg-[#003c2f]',
		collapsed: 'bg-[#3b8e7b] text-white',
		selected: 'bg-[#105742] text-white',
	},
	zolvix_plus_orange: {
		name: 'Zolvix Plus Orange',
		backgroundColor: '#ED7203',
		lightBackgroundColor: 'default',
		defaultStyle: 'bg-[#ED7203] text-black hover:bg-[#C25C00]',
		collapsed: 'bg-[#cfcbca] text-black hover:bg-[#a19c9c]',
		selected: 'bg-[#ED7203] text-black hover:bg-[#C25C00]',
	},
	eluracat_dark_pink: {
		name: 'Eluracat Dark Pink',
		backgroundColor: '#AB1368',
		lightBackgroundColor: 'default',
	},
	eluracat_light_pink: {
		name: 'Eluracat Light Pink',
		backgroundColor: '#E10098',
		lightBackgroundColor: 'default',
	},
	eluracat_yellow: {
		name: 'Eluracat Yellow',
		backgroundColor: '#FDBA12',
		lightBackgroundColor: 'default',
	},
	trucan_ultra_blue: {
		name: 'Trucan Ultra Blue',
		backgroundColor: '#1A4278',
		lightBackgroundColor: 'default',
	},
	trucan_ultra_yellow: {
		name: 'Trucan Ultra Yellow',
		backgroundColor: '#FCC924',
		lightBackgroundColor: 'default',
	},
	tru_crew_blue: {
		name: 'Tru Crew Blue',
		backgroundColor: '#304AC4',
		lightBackgroundColor: 'default',
	},
	tru_crew_mint: {
		name: 'Tru Crew Mint',
		backgroundColor: '#55E09F',
		lightBackgroundColor: 'default',
	},
	advocate_uc_gold: {
		name: 'Advocate UC Gold',
		backgroundColor: '#CCA144',
		lightBackgroundColor: 'default',
	},
	hemicell_orange: {
		name: 'Hemicell Orange',
		backgroundColor: '#CD6107',
		lightBackgroundColor: 'default',
	},
}
export const brandColorsMac: {
	codename: string
	name: string
}[] = []

Object.keys(brandColors).forEach((color: string) => {
	brandColorsMac.push({
		codename: color,
		name: brandColors[color]?.name || '',
	})
})
